import HeartConfirmation from './HeartConfirmation';
export default HeartConfirmation;
